<template>
  <div class="header-background">
    <div
      :class="['header-wrapper', { 'header-centered': centeredLogo }]"
    >
      <Asset
        :name="'logo-white.svg'"
        alt="Logo"
        title="Logo"
        :version="null"
      />
    </div>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';

export default {
  name: 'Header',
  components: { Asset },
  props: {
    centeredLogo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.header-background {
  background: linear-gradient(281.98deg, #25728D 0%, #36A3CA 52.1%, #72BEDA 99.4%);
}
.header-centered {
  justify-content: center;
}
.header-wrapper {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 50px;
  width: 100vw;
  padding-left: 24px;
}
img {
  height: auto;
  width: 140px;
}

.header-wrapper.header-centered {
  padding-left: unset;
}

@media (min-width: $lg) {
  .header-background {
    display: flex;
    justify-content: center;
  }
  .header-wrapper {
    padding-left: unset;
    max-width: 964px;
  }
  img {
    width: 150px;
  }
}

</style>
